// extracted by mini-css-extract-plugin
export default {"PieChart":"PieChart_PieChart__2dKd8","PieChartNullText":"PieChart_PieChartNullText__14diW"};